<template>
    <div class="totalReport wrapper">
        <proTitle></proTitle>
        <div class="toolbar">
            <el-form :inline="true" class="demo-form-inline toolbar-form" @submit.native.prevent>
                <div class="formInline-left">
                    <el-form-item>
                        <el-select v-model="filters.templateId" class="filter-type" clearable placeholder="全部类型"
                            @change="onFilterChange">
                            <el-option v-for="item in templates" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="filters.genStatus" class="filter-status" clearable placeholder="全部状态"
                            @change="onFilterChange">
                            <el-option v-for="item in genStatusOptions" :key="item.value" :label="item.label"
                                :value="item.value" />
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="filters.publishStatus" class="filter-publish" clearable placeholder="全部发布状态"
                            @change="onFilterChange">
                            <el-option v-for="item in publishStatusOptions" :key="item.value" :label="item.label"
                                :value="item.value" />
                        </el-select>
                    </el-form-item>
                    <el-form-item class="filter-search-item">
                        <el-input v-model.trim="filters.name" class="filter-search" clearable placeholder="搜索报告名称"
                            prefix-icon="el-icon-search" @input="onSearchInput" @clear="onFilterChange" />
                    </el-form-item>
                </div>
            </el-form>
            <el-button type="primary" class="toolbar-create" icon="el-icon-plus" @click="createReport">新建报告</el-button>
        </div>
        <div class="table_section" v-loading="loading">
            <template v-if="tableData.length">
                <el-table :data="tableData" border stripe style="width: 100%">
                    <el-table-column label="序号" width="56" align="center" type="index" :index="indexMethod" />
                    <el-table-column label="报告名称" align="center" min-width="160">
                        <template slot-scope="{ row }">
                            <span class="cell-clamp" :title="row.name">{{ row.name }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="报告类型" align="center" width="110">
                        <template slot-scope="{ row }">
                            <el-tag size="small" class="type-tag" :type="row.category === 'personal' ? '' : 'success'"
                                :title="row.templateName || '—'">
                                <span class="cell-clamp">{{ row.templateName || "—" }}</span>
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="数据范围" align="center" min-width="220">
                        <template slot-scope="{ row }">
                            <span class="cell-clamp" :title="scopeText(row)">{{ scopeText(row) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="状态" align="center" width="90">
                        <template slot-scope="{ row }">
                            <el-tooltip v-if="row.failReason" :content="row.failReason" placement="top">
                                <el-tag size="small" :type="genTag(row.genStatus)">
                                    {{ genLabel(row) }}
                                </el-tag>
                            </el-tooltip>
                            <el-tag v-else size="small" :type="genTag(row.genStatus)">{{ genLabel(row) }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="发布状态" align="center" width="90">
                        <template slot-scope="{ row }">
                            <el-tag size="small" :type="row.publishStatus === 'published' ? 'success' : 'info'">
                                {{ publishLabel(row) }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="生成时间" align="center" width="110">
                        <template slot-scope="{ row }">
                            <div class="time-cell">
                                <div class="time-date">{{ splitCreateTime(row.createTime).date }}</div>
                                <div v-if="splitCreateTime(row.createTime).clock" class="time-clock">
                                    {{ splitCreateTime(row.createTime).clock }}
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" min-width="260">
                        <template slot-scope="{ row }">
                            <div class="op-actions">
                                <el-button type="text" size="small" @click="openWizard('view', row)">查看</el-button>
                                <el-button type="text" size="small" @click="openRename(row)">编辑基本信息</el-button>
                                <el-button type="text" size="small" @click="openWizard('edit', row)">编辑报告</el-button>
                                <el-button type="text" size="small" @click="openPublish(row)">发布</el-button>
                                <el-button type="text" size="small" :disabled="row.publishStatus !== 'published'"
                                    @click="unpublish(row)">取消发布</el-button>
                                <el-button type="text" size="small" @click="remove(row)">删除</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <pagination :total="pages.total" :page.sync="pages.currentPage" :limit.sync="pages.pageSize"
                    :pageSizes="[10, 20, 30]" @pagination="handlePageChange" />
            </template>
            <el-empty v-else description="暂无报告，请点击「新建报告」开始生成" />
        </div>

        <el-dialog title="编辑基本信息" :visible.sync="renameVisible" width="480px" custom-class="rename-dialog"
            @closed="renameRow = null">
            <div class="rename-tip">
                <i class="el-icon-info"></i>
                <span>仅可修改报告名称，其他信息请通过「编辑报告」调整</span>
            </div>
            <el-form class="rename-form" label-width="80px" @submit.native.prevent>
                <el-form-item label="报告名称" required>
                    <el-input v-model.trim="renameName" maxlength="25" show-word-limit clearable
                        placeholder="请输入报告名称（最多 25 个字）" />
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="renameVisible = false">取消</el-button>
                <el-button type="primary" :loading="renameLoading" @click="saveRename">保存</el-button>
            </span>
        </el-dialog>

        <el-dialog title="发布" :visible.sync="publishVisible" width="30%" @closed="resetPublish">
            <div class="submit-box">
                <span class="sub-title">是否发布名为“{{ publishReportName }}”的报告？</span>
                <el-form :model="publishForm" label-position="left" label-width="80px" :rules="publishRules"
                    ref="publishFormRef">
                    <el-form-item label="标题名称" size="small" prop="name">
                        <el-input v-model="publishForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="顺序" size="small" prop="order">
                        <el-input v-model="publishForm.order"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="publishVisible = false">取 消</el-button>
                <el-button type="primary" :loading="publishLoading" @click="submitPublish">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {
        GEN_STATUS_OPTIONS,
        PUBLISH_STATUS_OPTIONS,
        formatScope,
        genStatusLabel,
        genStatusTag,
        publishStatusLabel,
    } from "./shared";

    export default {
        name: "reportV2List",
        data() {
            return {
                loading: false,
                tableData: [],
                templates: [],
                scopeOptions: {
                    stages: [],
                    userGroups: [],
                    areas: [],
                    cycles: [],
                    homeworks: [],
                    logs: [],
                    surveys: [],
                    reports: [],
                    attendanceDates: [],
                },
                filters: {
                    templateId: "",
                    genStatus: "",
                    publishStatus: "",
                    name: "",
                },
                pages: {
                    currentPage: 1,
                    pageSize: 10,
                    total: 0,
                },
                genStatusOptions: GEN_STATUS_OPTIONS,
                publishStatusOptions: PUBLISH_STATUS_OPTIONS,
                searchTimer: null,
                renameVisible: false,
                renameLoading: false,
                renameName: "",
                renameRow: null,
                publishVisible: false,
                publishLoading: false,
                publishVersionLoading: false,
                publishReportName: "",
                publishRow: null,
                publishVersionId: null,
                publishForm: {
                    name: "",
                    order: "",
                },
                publishRules: {
                    name: {
                        required: true,
                        message: "请输入标题名称",
                        trigger: "blur",
                    },
                    order: {
                        required: true,
                        message: "请输入顺序",
                        trigger: "blur",
                    },
                },
            };
        },
        computed: {
            projectId() {
                return this.$store.state.user.currentProject.id;
            },
        },
        mounted() {
            this.loadOptions();
            this.getList();
        },
        beforeDestroy() {
            if (this.searchTimer) clearTimeout(this.searchTimer);
        },
        methods: {
            indexMethod(index) {
                return this.pages.currentPage > 1
                    ? (this.pages.pageSize * (this.pages.currentPage - 1)) + index + 1
                    : index + 1;
            },
            genLabel(row) {
                return genStatusLabel(row.genStatus, row.genStatusLabel);
            },
            genTag(status) {
                return genStatusTag(status);
            },
            publishLabel(row) {
                return publishStatusLabel(row.publishStatus, row.publishStatusLabel);
            },
            scopeText(row) {
                return formatScope(row.scope, this.scopeOptions, row.dataType);
            },
            // 【修改】生成时间拆成日期与时分，秒不再展示；兼容空格或 T 分隔
            splitCreateTime(value) {
                if (value === null || value === undefined || String(value).trim() === "") {
                    return { date: "—", clock: "" };
                }
                const parts = String(value).trim().replace("T", " ").split(/\s+/);
                const date = parts[0] || "—";
                const segments = (parts[1] || "").split(":");
                const clock = segments.length >= 2 ? `${segments[0]}:${segments[1]}` : "";
                return { date, clock };
            },
            onFilterChange() {
                this.pages.currentPage = 1;
                this.getList();
            },
            onSearchInput() {
                if (this.searchTimer) clearTimeout(this.searchTimer);
                this.searchTimer = setTimeout(() => {
                    this.onFilterChange();
                }, 300);
            },
            handlePageChange(data) {
                this.pages.currentPage = data.pageIndex;
                this.pages.pageSize = data.pageSize;
                this.getList();
            },
            async loadOptions() {
                const projectId = this.projectId;
                try {
                    const [tplRes, scopeRes] = await Promise.all([
                        this.$Api.ReportV2.getTemplates({ projectId }),
                        this.$Api.ReportV2.getScopeOptions({ projectId }),
                    ]);
                    if (tplRes && tplRes.code == 200) {
                        const data = tplRes.data || {};
                        this.templates = data.rows || data || [];
                        if (!Array.isArray(this.templates)) this.templates = [];
                    }
                    if (scopeRes && scopeRes.code == 200 && scopeRes.data) {
                        this.scopeOptions = Object.assign({}, this.scopeOptions, scopeRes.data);
                    }
                } catch (e) {
                    this.$message.error("筛选项加载失败");
                }
            },
            async getList() {
                this.loading = true;
                const params = {
                    projectId: this.projectId,
                    page: this.pages.currentPage,
                    limit: this.pages.pageSize,
                };
                if (this.filters.templateId) params.templateId = this.filters.templateId;
                if (this.filters.genStatus) params.genStatus = this.filters.genStatus;
                if (this.filters.publishStatus) params.publishStatus = this.filters.publishStatus;
                if (this.filters.name) params.name = this.filters.name;
                try {
                    const res = await this.$Api.ReportV2.getList(params);
                    if (!res || res.code != 200) {
                        this.$message.error((res && res.msg) || "报告列表加载失败");
                        this.tableData = [];
                        this.pages.total = 0;
                        return;
                    }
                    const data = res.data || {};
                    this.tableData = data.rows || [];
                    this.pages.total = data.total || 0;
                } catch (e) {
                    this.$message.error("报告列表加载失败");
                } finally {
                    this.loading = false;
                }
            },
            createReport() {
                this.$router.push({ path: "/home/totalReportV2", query: { mode: "create" } });
            },
            openWizard(mode, row) {
                this.$router.push({
                    path: "/home/totalReportV2",
                    query: { mode, id: row.id },
                });
            },
            openRename(row) {
                this.renameRow = row;
                this.renameName = row.name || "";
                this.renameVisible = true;
            },
            async saveRename() {
                if (!this.renameName) {
                    this.$message.warning("请输入报告名称");
                    return;
                }
                this.renameLoading = true;
                try {
                    const res = await this.$Api.ReportV2.rename({
                        id: this.renameRow.id,
                        name: this.renameName,
                    });
                    if (!res || res.code != 200) {
                        this.$message.error((res && res.msg) || "保存失败");
                        return;
                    }
                    this.$message.success("基本信息已保存");
                    this.renameVisible = false;
                    this.getList();
                } catch (e) {
                    this.$message.error("保存失败");
                } finally {
                    this.renameLoading = false;
                }
            },
            resetPublish() {
                this.publishRow = null;
                this.publishVersionId = null;
                this.publishReportName = "";
                this.publishForm = { name: "", order: "" };
                if (this.$refs.publishFormRef) this.$refs.publishFormRef.clearValidate();
            },
            async openPublish(row) {
                if (this.publishVersionLoading) return;
                this.publishVersionLoading = true;
                try {
                    const res = await this.$Api.ReportV2.getVersions({ reportId: row.id });
                    if (!res || res.code != 200) {
                        this.$message.error((res && res.msg) || "版本加载失败");
                        return;
                    }
                    const rows = (res.data && res.data.rows) || [];
                    if (!rows.length) {
                        this.$message.warning("暂无可发布版本，请先生成报告");
                        return;
                    }
                    const newest = rows.reduce((max, item) => (Number(item.id) > Number(max.id) ? item : max));
                    this.publishRow = row;
                    this.publishReportName = row.name || "";
                    this.publishForm = { name: row.name || "", order: "" };
                    this.publishVersionId = newest.id;
                    this.publishVisible = true;
                    this.$nextTick(() => {
                        if (this.$refs.publishFormRef) this.$refs.publishFormRef.clearValidate();
                    });
                } catch (e) {
                    this.$message.error("版本加载失败");
                } finally {
                    this.publishVersionLoading = false;
                }
            },
            submitPublish() {
                if (!this.$refs.publishFormRef) return;
                this.$refs.publishFormRef.validate(async (valid) => {
                    if (!valid) return;
                    if (!this.publishVersionId) {
                        this.$message.warning("暂无可发布版本，请先生成报告");
                        return;
                    }
                    const publishSort = Number(String(this.publishForm.order).trim());
                    if (!Number.isFinite(publishSort)) {
                        this.$message.warning("请输入数字顺序");
                        return;
                    }
                    this.publishLoading = true;
                    try {
                        const res = await this.$Api.ReportV2.publish({
                            reportId: this.publishRow.id,
                            versionId: this.publishVersionId,
                            publishTitle: this.publishForm.name,
                            publishSort,
                        });
                        if (!res || res.code != 200) {
                            this.$message.error((res && res.msg) || "发布失败");
                            return;
                        }
                        this.$message.success("发布成功");
                        this.publishVisible = false;
                        this.getList();
                    } catch (e) {
                        this.$message.error("发布失败");
                    } finally {
                        this.publishLoading = false;
                    }
                });
            },
            unpublish(row) {
                if (row.publishStatus !== "published") return;
                this.$confirm("确认取消发布该报告？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(async () => {
                    try {
                        const res = await this.$Api.ReportV2.unpublish({ id: row.id });
                        if (!res || res.code != 200) {
                            this.$message.error((res && res.msg) || "取消发布失败");
                            return;
                        }
                        this.$message.success("已取消发布");
                        this.getList();
                    } catch (e) {
                        this.$message.error("取消发布失败");
                    }
                }).catch(() => { });
            },
            remove(row) {
                this.$confirm(`确认删除名为“${row.name}”的报告？`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(async () => {
                    try {
                        const res = await this.$Api.ReportV2.deleteReport({ id: row.id });
                        if (!res || res.code != 200) {
                            this.$message.error((res && res.msg) || "删除失败");
                            return;
                        }
                        this.$message.success("已删除");
                        this.getList();
                    } catch (e) {
                        this.$message.error("删除失败");
                    }
                }).catch(() => { });
            },
        },
    };
</script>

<style lang="less" scoped>
    @import "../../manage/less/table.less";

    .totalReport {
        padding: 20px 25px;
        box-sizing: border-box;

        /* 【修改】筛选与新建按钮合并为一行工具栏 */
        .toolbar {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 16px;
            margin-bottom: 14px;
        }

        .toolbar-form {
            flex: 1;
            min-width: 0;
        }

        .formInline-left {
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            gap: 12px;

            /deep/ .el-form-item {
                flex-shrink: 0;
            }
        }

        .filter-type {
            width: 176px;
        }

        .filter-status {
            width: 136px;
        }

        .filter-publish {
            width: 152px;
        }

        .filter-search-item {
            flex: 0 0 180px;
            width: 180px;
        }

        .filter-search {
            width: 180px;
        }

        .toolbar-create {
            flex-shrink: 0;
            height: 36px;
            line-height: 34px;
            padding: 0 20px;
            border-radius: 6px;
            font-weight: 500;
        }

        .table_section {
            margin-top: 0;
        }
    }

    /* 【修改】覆盖公共表格样式里的胶囊输入框，与按钮统一为 36 像素高、6 像素圆角 */
    .toolbar /deep/ .el-form--inline .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
    }

    .toolbar /deep/ .filter-search-item .el-form-item__content,
    .toolbar /deep/ .filter-search-item .el-input {
        width: 180px;
    }

    .toolbar /deep/ .el-form--inline .el-form-item .el-input__inner {
        height: 36px;
        line-height: 36px;
        border: 1px solid #dcdfe6;
        border-radius: 6px;
        color: #303133;
    }

    .toolbar /deep/ .el-form--inline .el-form-item .el-input__inner:hover {
        border-color: #c0c4cc;
    }

    .toolbar /deep/ .el-form--inline .el-form-item .el-input__inner:focus,
    .toolbar /deep/ .el-form--inline .el-form-item .el-input.is-focus .el-input__inner {
        border-color: #409eff;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
    }

    .toolbar /deep/ .el-input__icon {
        line-height: 36px;
    }

    /* 【修改】表格行距、表头层次、斑马纹与悬停 */
    .totalReport /deep/ .el-table td,
    .totalReport /deep/ .el-table th {
        padding-top: 11px;
        padding-bottom: 11px;
    }

    .totalReport /deep/ .el-table .cell {
        padding-left: 6px;
        padding-right: 6px;
        line-height: 20px;
        white-space: normal;
    }

    .totalReport /deep/ .el-table__header thead th {
        color: #59627a;
        font-weight: 500;
    }

    .totalReport /deep/ .el-table--striped .el-table__body tr.el-table__row--striped td {
        background: #fafbfe;
    }

    .totalReport /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
        background-color: #f2f6ff;
    }

    .totalReport /deep/ .el-table .el-tag--small {
        height: auto;
        padding: 0 7px;
        line-height: 20px;
        border-radius: 4px;
        white-space: normal;
    }

    /* 【修改】名称、类型、数据范围最多两行，悬停用 title 看全称 */
    .cell-clamp {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        word-break: break-all;
        white-space: normal;
        line-height: 20px;
    }

    .type-tag {
        max-width: 100%;
        height: auto;
        white-space: normal;
        box-sizing: border-box;
    }

    .time-date {
        color: #303133;
        line-height: 20px;
    }

    .time-clock {
        color: #909399;
        font-size: 12px;
        line-height: 20px;
    }

    .rename-hint {
        margin: 0;
        font-size: 12px;
        color: #909399;
        line-height: 20px;
    }

    .op-actions {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        row-gap: 6px;
        column-gap: 10px;
    }

    .op-actions .el-button {
        margin-left: 0;
        margin-right: 0;
        padding-left: 0;
        padding-right: 0;
        font-size: 13px;
    }

    .op-actions .el-button + .el-button {
        margin-left: 0;
    }

    /* 【修改】编辑基本信息弹窗，并盖掉公共样式里的横向弹性布局 */
    /deep/ .rename-dialog {
        .el-dialog__header {
            padding: 18px 22px 16px;
            border-bottom: 1px solid #f0f2f7;
        }

        .el-dialog__title {
            font-size: 16px;
            font-weight: 600;
            line-height: 24px;
            color: #1f2733;
        }

        .el-dialog__headerbtn {
            top: 18px;
            right: 22px;
        }

        .el-dialog__body {
            display: block;
            padding: 18px 22px 6px;
        }

        .el-dialog__footer {
            padding: 14px 22px 18px;
            border-top: 1px solid #f0f2f7;
            text-align: right;
        }
    }

    .rename-tip {
        display: flex;
        align-items: flex-start;
        gap: 6px;
        margin: 0 0 18px;
        padding: 8px 12px;
        background: #f4f8ff;
        border: 1px solid #dce8ff;
        border-radius: 6px;
        font-size: 12px;
        line-height: 18px;
        color: #5c7ba6;

        i {
            flex-shrink: 0;
            color: #409eff;
            font-size: 14px;
            line-height: 18px;
        }
    }

    .rename-form /deep/ .el-form-item__label {
        color: #59627a;
        white-space: nowrap;
    }

    .rename-form /deep/ .el-form-item {
        margin-bottom: 6px;
    }

    .rename-form /deep/ .el-input__inner {
        height: 36px;
        line-height: 36px;
        padding-right: 88px;
    }

    .rename-form /deep/ .el-input__icon {
        line-height: 36px;
    }

    .submit-box {
        width: 80%;

        .sub-title {
            display: block;
            margin-bottom: 20px;
        }
    }
</style>
